import Sentry from '@libraries/sentry/browser';

export enum UserConsentEvent {
	ConsentUpdate = 'UserConsentUpdate'
}

export default class UserConsentUtil {
	public static init(): void {
		window.addEventListener('CookiebotOnDialogDisplay', (): void => {
			UserConsentUtil.setInitialComplianceSettingsForPiwik();
		});

		window.addEventListener('CookiebotOnLoad', (): void => {
			window.dispatchEvent(new CustomEvent(UserConsentEvent.ConsentUpdate));
		});

		window.addEventListener('CookiebotOnAccept', (): void => {
			window.dispatchEvent(new CustomEvent(UserConsentEvent.ConsentUpdate));
			UserConsentUtil.setComplianceSettingsForPiwik();
		});

		window.addEventListener('CookiebotOnDecline', (): void => {
			window.dispatchEvent(new CustomEvent(UserConsentEvent.ConsentUpdate));
			UserConsentUtil.setComplianceSettingsForPiwik();
		});
	}

	public static get necessaryConsent(): boolean {
		const Cookiebot: any = UserConsentUtil.Cookiebot;

		return Cookiebot && Cookiebot.consent && Cookiebot.consent.necessary;
	}

	public static get preferencesConsent(): boolean {
		const Cookiebot: any = UserConsentUtil.Cookiebot;

		return Cookiebot && Cookiebot.consent && Cookiebot.consent.preferences;
	}

	public static get statisticsConsent(): boolean {
		const Cookiebot: any = UserConsentUtil.Cookiebot;

		return Cookiebot && Cookiebot.consent && Cookiebot.consent.statistics;
	}

	public static get marketingConsent(): boolean {
		const Cookiebot: any = UserConsentUtil.Cookiebot;

		return Cookiebot && Cookiebot.consent && Cookiebot.consent.marketing;
	}

	public static requestConsent(): void {
		if (!UserConsentUtil.Cookiebot) return;

		UserConsentUtil.Cookiebot.renew();
	}

	private static get Cookiebot(): any | null {
		const Cookiebot: any = (window as any).Cookiebot;

		if (!Cookiebot) {
			return null;
		}

		if (!Cookiebot.consent || !Cookiebot.renew) {
			// HTML Element with id="Cookiebot" found, but not the Cookiebot script
			return null;
		}

		return Cookiebot;
	}

	/**
	 * Piwik related methods in context of the consent layer
	 * See: https://help.piwik.pro/support/privacy/how-can-i-integrate-a-third-party-cookie-consent-tool-with-piwik-pro/
	 */

	public static setInitialComplianceSettingsForPiwik(): void {
		const api = UserConsentUtil.getPiwikApi();

		if (api) {
			api(
				'setInitialComplianceSettings',
				{ consents: ['analytics', 'marketing_automation'] },
				function onSuccess(): void {},
				function onError(error: Error): void {
					Sentry.captureException(error);
				}
			);
		}
	}

	public static setComplianceSettingsForPiwik(): void {
		const api = UserConsentUtil.getPiwikApi();

		if (api) {
			const booleanToNumber = (value: boolean): 0 | 1 => (value ? 1 : 0);

			api(
				'setComplianceSettings',
				{
					consents: {
						analytics: { status: booleanToNumber(UserConsentUtil.statisticsConsent) },
						// eslint-disable-next-line @typescript-eslint/camelcase
						marketing_automation: { status: booleanToNumber(UserConsentUtil.marketingConsent) }
					}
				},
				function onSuccess(): void {},
				function onError(error: Error): void {
					Sentry.captureException(error);
				}
			);
		}
	}

	public static getPiwikApi(): any | undefined {
		if (window.ppms && window.ppms.cm && window.ppms.cm.api) {
			return window.ppms.cm.api;
		}
	}
}
